import React, { useEffect, useState } from "react";
import Image from "components/image";
import Link from "helpers/link";
import formatDate from "helpers/format-date";
import { customBgColor } from "utils/module-settings";
import SrOnly from "components/sr-only";
import { sanityClient } from "build/sanity";

const Blog = ({ blog }) => (
    <div className="flex md:w-1/3 md:min-w-0 min-w-[20rem] flex-col py-4">
        <Link to={blog.handle.current} className="flex bg-inherit rounded-md overflow-hidden">
            <Image className="lg:max-h-36 max-h-28" imgClassName="image-hover-effect" image={blog?.image} alt={blog?.title} />
        </Link>
        <Link to={blog.handle.current}>
            <p className="text-blue-700 font-semibold mt-6 mb-4">
                {blog.title}
            </p>
        </Link>
        <p className="text-gray-601 mb-14">
            {formatDate(blog.date)}
        </p>
    </div>
);

const FeaturedBlogs = ({ data }) => {
    const { bgImage, moduleSettings, title } = data;
    const [blogs, setBlogs] = useState([]);

    const fetchBlogs = async () => {
        try {
            const query = `*[_type == "blog" && !(_id in path("drafts.**"))] | order(date desc) {
                ...
            }[0...3]`;
            const result = await sanityClient.fetch(query);
            setBlogs(result);
        } catch (err) {
            setBlogs([]);
        }
    };

    useEffect(() => {
        fetchBlogs();
    }, []);

    return (
        <div className="flex relative flex-col">
            <div className="bg-overlay flex relative h-48 before:bg-[#10222b] before:opacity-70">
                <Image
                    image={bgImage.asset}
                    className="flex w-full h-full"
                    width={1920}
                />
                <h3 className="abs-center text-white z-10 -mt-7">
                    {title}
                    <SrOnly label={title} />
                </h3>
            </div>
            <div style={{ backgroundColor: customBgColor(moduleSettings.bgColor) }} className="z-10 min-h-[220px]">
                <div className="container lg:-mt-[5.75rem] -mt-[4.625rem] flex md:overflow-x-auto overflow-x-scroll flex-nowrap gap-8">
                    {blogs && blogs?.map((blog) => (
                        <Blog key={blog._id} blog={blog} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FeaturedBlogs;
